import DashboardLayout from "@/packages/dashboard/modules/dashboard/views/dashboardLayout";
import Auth from "@/packages/dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "@/packages/dashboard/modules/auth/middleware/ProfileComplete";
import ExamWithdrawal from "./components/ExamWithdrawal.vue";
import ExamWithdrawalCard from "./components/ExamWithdrawalCard.vue";
import Exams from "@/packages/exams/view/exam";

export default [
  {
    path: "/exams",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Exams",
        component: Exams,
        children: [
          {
            path: "withdrawals",
            name: "Withdrawals",
            component: ExamWithdrawal,
            middleware: [Auth, ProfileComplete],
          },
          {
            path: "withdrawals/card/:code?",
            name: "ExamWithdrawalCard",
            component: ExamWithdrawalCard,
            middleware: [Auth, ProfileComplete],
          },
        ],
      },
    ],
  },
];
